import axios from 'axios';
import config from '../common/config';

export default {
  getConfig( token ) {
    return axios.get(`${config.config.ROOT_URL}/api/whatsapp_test/config`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  },
  getTemplates( token ) {
    return axios.get(`${config.config.ROOT_URL}/api/whatsapp_test/templates`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  },
  sendMessage( token, payload ) {
    return axios.post(`${config.config.ROOT_URL}/api/whatsapp_test/send`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
  }
};
